import { createRoot } from 'react-dom/client';
import { AppResolver } from 'ui/components/App/AppResolver';

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);

  root.render(<AppResolver />);
}
